import { render, staticRenderFns } from "./setCon2.vue?vue&type=template&id=40a19569&scoped=true&"
import script from "./setCon2.vue?vue&type=script&lang=js&"
export * from "./setCon2.vue?vue&type=script&lang=js&"
import style0 from "./setCon2.vue?vue&type=style&index=0&id=40a19569&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a19569",
  null
  
)

export default component.exports